(function (algolia) {
  'use strict';
  var instantsearch = algolia.externals.instantsearch;
  var algoliasearch = algolia.externals.algoliasearch;
  var relatedProducts = algolia.externals.widgets.relatedProducts;
  var frequentlyBoughtTogether = algolia.externals.widgets.frequentlyBoughtTogether;
  var trendingItems = algolia.externals.widgets.trendingItems;
  var html = algolia.externals.html;

  function getTrackedUiState(uiState) {
    var trackedUiState = {};
    Object.keys(uiState).forEach(function (k) {
      if (k === 'configure' || k === 'query' || k === 'q') {
        return;
      }
      trackedUiState[k] = uiState[k];
    });
    return trackedUiState;
  }

  /**
   * List of URL params which are "allowed" by InstantSearch.
   * These parameters won't be overwritten when the search state is written
   * to the URL.
   */
  var ALLOWED_FOREIGN_PARAMS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content',
  ];
  var foreignRouteState;

  function singleIndex(indexName) {
    return {
      /**
       * `stateToRoute` method transforms the `uiState` object from InstantSearch
       * into an object that will then be serialized to construct the URL.
       */
      stateToRoute: function (uiState) {
        var route = getTrackedUiState(uiState[indexName] || {});
        route.q = uiState[indexName].query;
        return Object.assign({}, foreignRouteState, route);
      },

      /**
       * `routeToState` method transforms the route object into a `uiState` object
       * so that InstantSearch is initialized with the correct state from the
       * URL.
       */
      routeToState: function (routeState) {
        /**
         * Backup parameters from `routeState` into a different object
         * `foreignRouteState` so that we can re-inject them into the object
         * returned within `stateToRoute`.
         * This allows us to preserve the parameters specified in `ALLOWED_FOREIGN_PARAMS`
         * array.
         */

        const urlParams = new URLSearchParams(window.location.search);
        const queryParamKeys = Array.from(urlParams.keys());
        ALLOWED_FOREIGN_PARAMS = ALLOWED_FOREIGN_PARAMS.concat(queryParamKeys);

        if (!foreignRouteState) {
          foreignRouteState = ALLOWED_FOREIGN_PARAMS.reduce(function (acc, key) {
            acc[key] = routeState[key];
            return acc;
          }, {});
        }

        var state = {};
        state[indexName] = getTrackedUiState(routeState || {});
        state[indexName].query = routeState.q;
        return state;
      },
    };
  }

  var instant = {
    colors: algolia.config.colors,
    distinct: Boolean(algolia.config.show_products),
    search: instantsearch({
      searchClient: algoliasearch(
        algolia.config.app_id,
        algolia.config.search_api_key
      ),
      insights: algolia.config.analytics_enabled,
      indexName: algolia.config.index_prefix + 'products',
      routing: false,
      searchFunction: function (searchFunctionHelper) {
        // Set query parameters here because they're not kept when someone
        // presses the Back button if set in the `init` function of a custom widget
        var page = searchFunctionHelper.getPage();
        if (instant.distinct) {
          searchFunctionHelper.setQueryParameter('distinct', true);
        }


        searchFunctionHelper.setQueryParameter('facetingAfterDistinct', false);

        searchFunctionHelper.setPage(page);
        searchFunctionHelper.search();
      },
    }),
  };

  instant.search.client.addAlgoliaAgent('Shopify Integration');

  algolia.instantsearch = instant;

  //Link CSS and set up CSS variables
  const cssFile = document.getElementById('template_algolia_instant_search.css');
  document.documentElement.style.setProperty(`--main-color`, `${algolia.config.colors.main}`);
  document.documentElement.style.setProperty(`--secondary-color`, `${algolia.config.colors.secondary}`);
  document.documentElement.style.setProperty(`--highlight-bg-color`, `${algolia.helpers.hexToRGB(algolia.config.colors.highlight)}`);
  algolia.appendStyle(cssFile.text);

/*
 * Returns widget parameters 
 *
 * @param {string} title - The title for the widget
 * @param {string} selector - the selector if the widget container
 * @param {object} additionalParameters - unique parameters or parameters not common in all widgets
 * 
 */

  function getWidgetParameters({selector,title, minHits, additionalParameters}){
    const Title = () => {
        return html`
          <div class="shop-collection-title widget-title h-10 mt-0 mb-6 md:mb-3 md:mx-0 flex items-center">
            <span>${title}</span>
          </div>
        `;
    }
    return {
      container:selector,
      templates:{
        header({ cssClasses, items }, { html }) {
          return html`<div></div>`;
        },
        item(recommendation, { html, components }) {
          return algolia.productCard(html,recommendation);
        },
        empty(_,{ html }){//displays nothing when there's no result
          return html`<div></div>`
        },
        layout({items},{html}){
          if(minHits && items.length < minHits){
            return html`<div></div>`
          }
          return html`
            <div class="pdp-shop-the-collection carousel__font flex flex-wrap glide gap-y-1">
              ${title ? html`<${Title}/>` : ''}
              <div class="glide__arrows hidden md:flex ml-auto" data-glide-el="controls">
                <button class="glide__arrow glide__arrow--left border-none shadow-none rounded-none p-0" data-glide-dir="|<">
                  <svg width="30" height="60" viewBox="10 4 20 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M22.5039 25.4546L15.7645 20.4C15.4978 20.2 15.4978 19.8 15.7645 19.6L22.5039 14.5455" stroke="black" stroke-linecap="round"/>
                  </svg>
                </button>
                <button class="glide__arrow glide__arrow--right border-none shadow-none rounded-none p-0" data-glide-dir="|>">
                <svg width="30" height="60" viewBox="8 4 20 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M17.4961 14.5454L24.2355 19.6C24.5022 19.8 24.5022 20.2 24.2355 20.4L17.4961 25.4545" stroke="black" stroke-linecap="round"/>
                </svg>
                </button>
              </div>
              <div class="glide__track widget-root -mr-4 md:-mx-4 lg:-mx-8 xl:-mx-12 w-screen" data-glide-el="track">
                <ul class="glide__slides">
                  ${items.map(item => html`<li class="glide__slide">${algolia.productCard(html,item,algolia.customSendEvent)}</li>`)}
                </ul>
              </div>
            </div>
          `;
        },
      },
      transformItems(items,{results}) {
        return items.map( (item,index) => ({
          ...item,
          queryID: results.queryID,
          index: results.index,
          itemPosition: index+1,
        }));
      },
      ...additionalParameters
    }
  }
  let queryParams = {clickAnalytics: true};
  // Retrieve product id from json in the page
  const json = document.querySelector('.js-product-json');
  const jsonData = json ? JSON.parse(json.innerHTML) : {};
  const { selectedOrFirstAvailableVariant = '' } = jsonData;
  const hasRelatedProducts = document.querySelector('#related-products');
  const relatedProductsParams = {
    selector: '#related-products',
    additionalParameters:{
      objectIDs: [`${selectedOrFirstAvailableVariant}`]
    },
  }

  if (hasRelatedProducts || selectedOrFirstAvailableVariant) {
    // lookingSimilar - recommend API
    instant.search.addWidgets([
      relatedProducts({
        queryParameters: {
          analyticsTags: ['related-products'],
          ...queryParams
        },
        ...getWidgetParameters(relatedProductsParams),
      }),
    ]);
  }
  //Frequently Bought Together Carousel widget for cart
  const hasFrequentlyBoughtTogether = document.querySelector("#frequently-bought-together")
  const cartJson = document.querySelector(".data-cartItems")
  if(hasFrequentlyBoughtTogether && cartJson){
    let cartItemIDs = JSON.parse(cartJson.innerHTML);
    const freqBoughtTogetherParams = {
      selector: '#frequently-bought-together',
      title: 'Frequently Bought Together',
      additionalParameters:{
        objectIDs: cartItemIDs
      },
    }
    let widgetParams = getWidgetParameters(freqBoughtTogetherParams)
    instant.search.addWidgets([
      frequentlyBoughtTogether({
        queryParameters: {
          analyticsTags: ['frequently_bought_together'],
          ...queryParams
        },
        ...widgetParams
      })
    ])
  }
  //Trending items carousel widget
  const trendingItemsContainer = document.querySelector('#trending-items')
  const collectionHandle = trendingItemsContainer?.dataset?.collectionHandle;
  const trendingItemsParams = {
    selector: '#trending-items',
    title: 'Trending Items',
    min_hits: 8,
  };
  if(trendingItemsContainer){
    let widgetParams = getWidgetParameters(trendingItemsParams)
    if(collectionHandle){
      widgetParams.facetName='collections';
      widgetParams.facetValue=collectionHandle;
    }
    instant.search.addWidgets([
      trendingItems({
        queryParameters: {
          analyticsTags: ['trending-items'],
          ...queryParams,
          filters:'NOT named_tags.algolia-hidden:true AND NOT tags:hidetrending AND inventory_available:true',
        },
        ...widgetParams
      })
    ])
  }
  
  instant.search.on('render',()=>{
    const event = new Event('carouselGlideReady');
    const widgetContainers = document.querySelectorAll('.recommend-glide-container');
    widgetContainers.forEach(container=>{
      if(container.querySelector('.glide')){
        container.dispatchEvent(event);
      }
    })
  })

  instant.search.start();

})(window.algoliaShopify);

